var _regeneratorRuntime = require("/builds/-nEQ4ZiW/0/EEX/frontend/wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var crypto = require('crypto');

var _require = require('./utils'),
    checkAndInit = _require.checkAndInit,
    smix = _require.smix; // N = Cpu cost, r = Memory cost, p = parallelization cost


function scrypt(key, salt, N, r, p, dkLen, progressCallback, promiseInterval) {
  var _checkAndInit, XY, V, B32, x, _X, B, tickCallback, i;

  return _regeneratorRuntime.async(function scrypt$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _checkAndInit = checkAndInit(key, salt, N, r, p, dkLen, progressCallback), XY = _checkAndInit.XY, V = _checkAndInit.V, B32 = _checkAndInit.B32, x = _checkAndInit.x, _X = _checkAndInit._X, B = _checkAndInit.B, tickCallback = _checkAndInit.tickCallback;
          i = 0;

        case 2:
          if (!(i < p)) {
            _context.next = 8;
            break;
          }

          _context.next = 5;
          return _regeneratorRuntime.awrap(smix(B, i * 128 * r, r, N, V, XY, _X, B32, x, tickCallback, promiseInterval));

        case 5:
          i++;
          _context.next = 2;
          break;

        case 8:
          return _context.abrupt("return", crypto.pbkdf2Sync(key, B, 1, dkLen, 'sha256'));

        case 9:
        case "end":
          return _context.stop();
      }
    }
  });
}

module.exports = scrypt;